(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["behind-the-seams"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const MAX_FILES = 4
    const MAX_FILE_BYTES = 8 * 1024 * 1024
    const MAX_TOTAL_BYTES = 20 * 1024 * 1024
    const ACCEPTED_TYPES = [
      'application/pdf',
      'application/msword',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      'application/vnd.ms-powerpoint',
      'application/vnd.openxmlformats-officedocument.presentationml.presentation',
      'image/jpeg',
      'image/png',
      'image/webp',
    ]
    const ACCEPTED_EXTENSIONS = ['pdf', 'doc', 'docx', 'ppt', 'pptx', 'jpg', 'jpeg', 'png', 'webp']
    const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    const OTHER = 'Other:'

    const withScheme = (value) => {
      const trimmed = value.trim()
      return !trimmed || /^https?:\/\//i.test(trimmed) ? trimmed : `https://${trimmed}`
    }

    const isAcceptedFile = (file) => {
      const extension = file.name.split('.').pop()?.toLowerCase()
      return ACCEPTED_TYPES.includes(file.type) || (!file.type && ACCEPTED_EXTENSIONS.includes(extension))
    }

    const formatMegabytes = (bytes) => `${(bytes / 1024 / 1024).toFixed(1)} MB`

    const init = (root) => {
      if (root.dataset.btsReady) return
      root.dataset.btsReady = 'true'

      // `t` HTML-escapes its output (an apostrophe arrives as &#39;), which is right in
      // markup but shows literally once these strings are set as textContent.
      const decode = (value) =>
        typeof value === 'string'
          ? new DOMParser().parseFromString(value, 'text/html').documentElement.textContent
          : Object.fromEntries(Object.entries(value).map(([key, inner]) => [key, decode(inner)]))
      const strings = decode(JSON.parse(root.querySelector('[data-bts-strings]').textContent))
      const endpoint = root.dataset.endpoint
      const form = root.querySelector('[data-bts-form]')
      const formSection = root.querySelector('#enquiry-form')
      const allSteps = [...form.querySelectorAll('[data-step]')]
      const stepLabel = form.querySelector('[data-step-label]')
      const progress = form.querySelector('[data-progress]')
      const backButton = form.querySelector('[data-back]')
      const nextButton = form.querySelector('[data-next]')
      const submitButton = form.querySelector('[data-submit]')
      const submitLabel = form.querySelector('[data-submit-label]')
      const serverError = form.querySelector('[data-server-error]')
      const success = root.querySelector('[data-success]')
      const honeypot = form.querySelector('#companyWebsite')
      const startedAt = Date.now()
      const files = {}
      let currentKey = 'contact'

      const questionEl = (id) => form.querySelector(`[data-question="${id}"]`)

      const valueOf = (id) => {
        const question = questionEl(id)
        const kind = question.dataset.kind
        if (kind === 'radio') return form.querySelector(`input[name="${id}"]:checked`)?.value ?? ''
        if (kind === 'checkboxes') {
          return [...form.querySelectorAll(`input[name="${id}"]:checked`)].map((input) => input.value)
        }
        if (kind === 'file') return files[id] ?? []
        return form.querySelector(`#${id}`).value
      }

      const hasAnswer = (value) => (Array.isArray(value) ? value.length > 0 : value.trim().length > 0)

      const otherSelected = (id) => {
        const value = valueOf(id)
        return Array.isArray(value) ? value.includes(OTHER) : value === OTHER
      }

      // The opening steps, the steps of whichever path q13 picked, then the closing one.
      const activeSteps = () => {
        const path = valueOf('q13')
        return allSteps.filter((step) => !step.dataset.path || step.dataset.path === path)
      }

      const setError = (id, message) => {
        const error = form.querySelector(`#${CSS.escape(id)}-error`)
        const field = form.querySelector(`#${CSS.escape(id)}`) ?? form.querySelector(`[name="${id}"]`)
        const question = questionEl(id.replace(/Other$/, ''))
        if (error) {
          error.textContent = message || ''
          error.hidden = !message
        }
        if (!id.endsWith('Other')) question?.classList.toggle('is-invalid', !!message)
        form.querySelectorAll(`[name="${id}"], #${CSS.escape(id)}`).forEach((input) => {
          if (message) {
            input.setAttribute('aria-invalid', 'true')
          } else {
            input.removeAttribute('aria-invalid')
          }
        })
        return field
      }

      const validateQuestion = (question) => {
        const id = question.dataset.question
        const kind = question.dataset.kind
        const value = valueOf(id)
        const errors = {}

        if (question.hasAttribute('data-required') && !hasAnswer(value)) {
          errors[id] = strings.errors.required
        } else if (kind === 'email' && value.trim() && !EMAIL_PATTERN.test(value.trim())) {
          errors[id] = strings.errors.email
        } else if (kind === 'url' && value.trim()) {
          try {
            const url = new URL(withScheme(value))
            if (url.protocol !== 'https:' && url.protocol !== 'http:') throw new Error('protocol')
          } catch {
            errors[id] = strings.errors.url
          }
        } else if (kind === 'file') {
          if (value.length > MAX_FILES) errors[id] = strings.errors.fileCount
          else if (value.some((file) => file.size > MAX_FILE_BYTES)) errors[id] = strings.errors.fileSize
          else if (value.some((file) => !isAcceptedFile(file))) errors[id] = strings.errors.fileType
          else if (value.reduce((total, file) => total + file.size, 0) > MAX_TOTAL_BYTES) errors[id] = strings.errors.fileTotal
        }

        const otherInput = form.querySelector(`#${id}Other`)
        if (otherInput && otherSelected(id) && !otherInput.value.trim()) {
          errors[`${id}Other`] = strings.errors.other
        }

        setError(id, errors[id])
        if (otherInput) setError(`${id}Other`, errors[`${id}Other`])
        return errors
      }

      const validateStep = (step) => {
        const errors = [...step.querySelectorAll('[data-question]')].reduce(
          (all, question) => ({ ...all, ...validateQuestion(question) }),
          {}
        )
        const firstId = Object.keys(errors)[0]
        if (!firstId) return true
        const field = form.querySelector(`#${CSS.escape(firstId)}`) ?? form.querySelector(`[name="${firstId}"]`)
        field?.closest('.bts-question')?.scrollIntoView({ behavior: 'smooth', block: 'center' })
        field?.focus({ preventScroll: true })
        return false
      }

      const render = () => {
        const steps = activeSteps()
        const index = Math.max(0, steps.findIndex((step) => step.dataset.step === currentKey))
        const isLast = index === steps.length - 1
        allSteps.forEach((step) => {
          step.hidden = step !== steps[index]
        })
        stepLabel.textContent = strings.stepLabel
          .replace('__current__', index + 1)
          .replace('__total__', steps.length)
        progress.style.width = `${((index + 1) / steps.length) * 100}%`
        backButton.hidden = index === 0
        nextButton.hidden = isLast
        submitButton.hidden = !isLast
      }

      const goTo = (offset) => {
        const steps = activeSteps()
        const index = steps.findIndex((step) => step.dataset.step === currentKey)
        const target = steps[index + offset]
        if (!target) return
        currentKey = target.dataset.step
        serverError.hidden = true
        render()
        formSection.scrollIntoView({ behavior: 'smooth', block: 'start' })
      }

      const renderFiles = (id) => {
        const list = form.querySelector(`[data-file-list="${id}"]`)
        list.replaceChildren(
          ...(files[id] ?? []).map((file, fileIndex) => {
            const item = document.createElement('li')
            item.className = 'bts-upload__item'
            const name = document.createElement('span')
            name.className = 'bts-upload__name'
            name.textContent = `${file.name} `
            const size = document.createElement('small')
            size.textContent = formatMegabytes(file.size)
            name.append(size)
            const remove = document.createElement('button')
            remove.type = 'button'
            remove.className = 'bts-upload__remove'
            remove.textContent = strings.removeFile
            remove.setAttribute('aria-label', strings.removeFileAria.replace('__name__', file.name))
            remove.addEventListener('click', () => {
              files[id] = files[id].filter((_, index) => index !== fileIndex)
              renderFiles(id)
              validateQuestion(questionEl(id))
            })
            item.append(name, remove)
            return item
          })
        )
      }

      const collectAnswers = () => {
        const ids = activeSteps().flatMap((step) =>
          [...step.querySelectorAll('[data-question]')].map((question) => question.dataset.question)
        )
        const answers = {}
        ids.forEach((id) => {
          if (questionEl(id).dataset.kind === 'file') return
          const value = valueOf(id)
          if (hasAnswer(value)) answers[id] = Array.isArray(value) ? value : value.trim()
          const otherInput = form.querySelector(`#${id}Other`)
          if (otherInput && otherSelected(id) && otherInput.value.trim()) answers[`${id}Other`] = otherInput.value.trim()
        })
        return { ids, answers }
      }

      const submit = async () => {
        const step = allSteps.find((candidate) => candidate.dataset.step === currentKey)
        if (!validateStep(step)) return

        const { ids, answers } = collectAnswers()
        const body = new FormData()
        body.append('answers', JSON.stringify(answers))
        body.append('startedAt', String(startedAt))
        body.append('companyWebsite', honeypot.value)
        ids
          .filter((id) => questionEl(id).dataset.kind === 'file')
          .forEach((id) => (files[id] ?? []).forEach((file) => body.append(id, file, file.name)))

        submitButton.disabled = true
        submitLabel.textContent = strings.sending
        serverError.hidden = true

        try {
          const response = await fetch(endpoint, { method: 'POST', body })
          const result = await response.json().catch(() => ({}))
          // The worker names the question it rejected (`field`); take the shopper to it
          // rather than leaving a message at the foot of an unrelated step.
          if (!response.ok && result.field && questionEl(result.field.replace(/Other$/, ''))) {
            const owner = questionEl(result.field.replace(/Other$/, '')).closest('[data-step]')
            if (owner && activeSteps().includes(owner)) {
              currentKey = owner.dataset.step
              render()
              const field = setError(result.field, result.error || strings.errors.submit)
              field?.closest('.bts-question')?.scrollIntoView({ behavior: 'smooth', block: 'center' })
              field?.focus({ preventScroll: true })
              return
            }
          }
          if (!response.ok) throw new Error(result.error || strings.errors.submit)
          form.hidden = true
          success.hidden = false
          success.scrollIntoView({ behavior: 'smooth', block: 'start' })
          success.focus({ preventScroll: true })
        } catch (error) {
          serverError.textContent = error instanceof Error && error.message ? error.message : strings.errors.submit
          serverError.hidden = false
        } finally {
          submitButton.disabled = false
          submitLabel.textContent = strings.submit
        }
      }

      form.addEventListener('change', (event) => {
        const input = event.target
        const question = input.closest('[data-question]')
        if (!question) return
        const id = question.dataset.question

        if (input.type === 'file') {
          files[id] = [...(input.files ?? [])]
          input.value = ''
          renderFiles(id)
        }

        const other = form.querySelector(`[data-other-for="${id}"]`)
        if (other) other.hidden = !otherSelected(id)

        if (input.type === 'radio' || input.type === 'checkbox' || input.type === 'file') {
          question.querySelectorAll('.bts-choice').forEach((choice) => {
            choice.classList.toggle('is-selected', choice.querySelector('input').checked)
          })
          validateQuestion(question)
        }
        // A new path changes the step count.
        if (id === 'q13') render()
      })

      // Clear a question's error as soon as it is edited, like the original.
      form.addEventListener('input', (event) => {
        const question = event.target.closest('[data-question]')
        if (!question) return
        const id = event.target.id.endsWith('Other') ? event.target.id : question.dataset.question
        setError(id, '')
      })

      form.addEventListener(
        'blur',
        (event) => {
          const question = event.target.closest('[data-question]')
          if (question?.dataset.kind !== 'url' || event.target.id !== question.dataset.question) return
          event.target.value = withScheme(event.target.value)
        },
        true
      )

      nextButton.addEventListener('click', () => {
        const step = allSteps.find((candidate) => candidate.dataset.step === currentKey)
        if (validateStep(step)) goTo(1)
      })
      backButton.addEventListener('click', () => goTo(-1))
      form.addEventListener('submit', (event) => {
        event.preventDefault()
        submit()
      })
      // Enter in a single-line field must not skip the step's validation.
      form.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' || event.target.tagName !== 'INPUT') return
        event.preventDefault()
        if (!submitButton.hidden) submit()
        else nextButton.click()
      })

      render()
    }

    const initAll = () => document.querySelectorAll('[data-behind-the-seams]').forEach(init)
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll)
    else initAll()
    document.addEventListener('shopify:section:load', initAll)
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["component-fabric-showcase"] && !Shopify.designMode) return;
  try {
    
  function knobbyNormalizeFabricMaterial(handle) {
    var normalized = (handle || '').toString().trim().toLowerCase();
    return normalized === 'naturals' ? 'naturals' : 'bottleblend';
  }

  function knobbySyncFabricProductImage(panel, styleKey) {
    if (!panel || !styleKey) return;

    var imageMap = {};
    try {
      imageMap = JSON.parse(panel.getAttribute('data-pdp-style-images') || '{}');
    } catch (error) {
      imageMap = {};
    }

    var productImage = panel.querySelector('[data-pdp-fabric-product-image]');
    if (!productImage) return;

    var nextSrc = imageMap[styleKey] || imageMap.trunk || productImage.dataset.src;
    if (nextSrc && window.knobbyPdpComponentImage?.updateSrc) {
      window.knobbyPdpComponentImage.updateSrc(productImage, nextSrc);
    }
  }

  function knobbySyncFabricShowcase(materialHandle, styleKey) {
    if (!materialHandle) return;

    var material = knobbyNormalizeFabricMaterial(materialHandle);

    document.querySelectorAll('[data-pdp-showcase="fabric"]').forEach(function (section) {
      section.setAttribute('data-pdp-material', material);
      if (styleKey) section.setAttribute('data-pdp-style', styleKey);
    });

    document.querySelectorAll('[data-pdp-material-panel]').forEach(function (panel) {
      var isActive = panel.getAttribute('data-pdp-material-panel') === material;
      panel.classList.toggle('component-fabric-showcase__panel--active', isActive);
      if (isActive) knobbySyncFabricProductImage(panel, styleKey);
    });
  }

  window.knobbySyncFabricShowcase = knobbySyncFabricShowcase;

  window.addEventListener('knobby:pdp-material-change', function (event) {
    var detail = event && event.detail ? event.detail : {};
    knobbySyncFabricShowcase(detail.material, detail.style);
  });

  window.dispatchEvent(new CustomEvent('knobby:fabric-showcase-ready'));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["portal-dashboard"]) return;
  try {
    
  ;(() => {
    const frame = document.querySelector('.portal-dashboard__frame[data-knobby-portal-url]')
    if (!frame) return

    const portalUrl = frame.dataset.knobbyPortalUrl || 'https://portal.knobby.com.au'
    const portalTrustedOrigins = ['https://portal.knobby.com.au']
    const storefrontHostname = window.location.hostname

    function buildPortalEmbedUrl() {
      const url = new URL(portalUrl)
      url.searchParams.set('embed', '1')
      url.searchParams.set('parent_origin', window.location.origin)
      return url.toString()
    }

    function syncHeaderOffset() {
      const header =
        document.querySelector('.header-section') ||
        document.querySelector('#component-header') ||
        document.querySelector('#shopify-section-component-header')
      const offset = header ? Math.round(header.getBoundingClientRect().bottom) : 0
      document.documentElement.style.setProperty('--portal-dashboard-header-offset', offset + 'px')
    }

    function isStorefrontUrl(href) {
      if (!href) return false
      try {
        const url = new URL(href, window.location.origin)
        if (url.protocol !== 'http:' && url.protocol !== 'https:') return false
        if (url.origin === window.location.origin) return true
        if (url.hostname === storefrontHostname) return true
        return url.hostname.endsWith('.knobby.com.au') && !url.hostname.startsWith('portal.')
      } catch (_) {
        return false
      }
    }

    function handlePortalMessage(event) {
      if (!portalTrustedOrigins.includes(event.origin)) return
      const data = event.data
      if (!data) return

      if (typeof data === 'string' && isStorefrontUrl(data)) {
        window.location.assign(new URL(data, window.location.origin).href)
        return
      }

      if (typeof data !== 'object') return

      const messageType = data.type || data.action
      const href = data.url || data.href || data.location || data.payload?.url

      if (
        messageType === 'knobby-portal-navigate' ||
        messageType === 'knobby-portal-exit' ||
        messageType === 'navigate'
      ) {
        if (href && isStorefrontUrl(href)) {
          window.location.assign(new URL(href, window.location.origin).href)
        }
      }
    }

    syncHeaderOffset()
    window.addEventListener('resize', syncHeaderOffset)
    window.addEventListener('message', handlePortalMessage)
    frame.src = buildPortalEmbedUrl()
  })()

  } catch(e) { console.error(e); }
})();
})();
